import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { HiTrendingUp } from "react-icons/hi";
import { IoIosCloseCircle } from "react-icons/io";
import { fetchApi } from "../utils/apiHelper";
import { getTour, getTiming, BaseUrl } from "../config/config";
import { addToCart, removeFromCart } from "../redux/cartSlice";

const BookingFormContent = ({ apiEndpoint, routeId }) => {
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);

  const [categories, setCategories] = useState([]);
  const [tourDetails, setTourDetails] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [shopId, setShopId] = useState("");
  const [categoryId, setCategoryId] = useState(null);
  const [tourId, setTourId] = useState(null);

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const defaultDate =
 tomorrow.toISOString().split("T")[0];
  // const defaultDate = tomorrow.toISOString().split("T")[0];

  const [selectedDate, setSelectedDate] = useState(defaultDate);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [showWarning, setShowWarning] = useState(false);

  const highlightEvent = [
    {
      start: selectedDate,
      end: selectedDate,
      display: "background",
      backgroundColor: "#00C4FF",
    },
  ];

  useEffect(() => {
  let isMounted = true;

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("token");
      const data = await fetchApi(apiEndpoint.url, {
        method: apiEndpoint.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!isMounted) return; // component was torn down (tab switched)

      setCategories(data.category || []);
      if (data.category && data.category.length > 0) {
        setCategoryId(data.category[0].id);
      }
      setShopId(data.shop_id);
      setLoading(false);
    } catch (error) {
      if (!isMounted) return;
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  fetchCategories();

  return () => {
    isMounted = false; // runs on unmount, i.e. when routeId/key changes
  };
}, [apiEndpoint, routeId]);

  // const fetchCategories = async () => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     const data = await fetchApi(apiEndpoint.url, {
  //       method: apiEndpoint.method,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });
 
  //     setCategories(data.category || []);

  //     if (data.category && data.category.length > 0) {
  //       setCategoryId(data.category[0].id);
  //     }
  //     setShopId(data.shop_id);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     setLoading(false);
  //   }
  // };

  const fetchTourDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const data = await fetchApi(getTour.url, {
        method: getTour.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopids: shopId,
          categoryid: categoryId,
        }),
      });

      setTourDetails(data.tours || []);
      if (data.tours && data.tours.length > 0) {
        setTourId(data.tours[0].id);
      } else {
        setTourId(null);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const fetchTimeSlots = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const data = await fetchApi(getTiming.url, {
        method: getTiming.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopidss: shopId,
          categoryids: categoryId,
          priceid: tourId,
          tour_date: selectedDate,
        }),
      });
      setTimeSlots(data.timings || []);
     
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Reset selections on route change
    setCategories([]);
    setTourDetails([]);
    setTimeSlots([]);
    setCategoryId(null);
    setTourId(null);
    setSelectedTime(null);
    setSelectedOption(null);

    // fetchCategories();
  }, [apiEndpoint, routeId]);

  useEffect(() => {
    if (shopId && categoryId) {
      fetchTourDetails();
    }
  }, [shopId, categoryId, routeId]);

  useEffect(() => {
    if (shopId && categoryId && tourId) {
      fetchTimeSlots();
    }
  }, [shopId, categoryId, tourId, selectedDate, routeId]);

  const handleDateClick = (info) => {
    if (info.dateStr < defaultDate) return;
    setSelectedDate(info.dateStr);
    setSelectedTime(null);
    setSelectedOption(null);
    setShowWarning(true);
  };

  const handleAddToCart = () => {
    if (!selectedDate) {
      toast.error("Please select a date");
      return false;
    }
    if (!selectedTime) {
      toast.error("Please select a time slot");
      return false;
    }
    if (!selectedOption) {
      toast.error("Please select number of rides");
      return false;
    }

    const currentTour = tourDetails.find((t) => t.id === tourId);

    if (routeId === "asakusa") {
      const cartItem = {
        id: `${shopId}-${categoryId}-${tourId}-${selectedDate}-${selectedTime.id}-${Date.now()}`,
        shopId,
        categoryId,
        tourId,
        date: selectedDate,
        timeSlot: selectedTime,
        rideCount: Number(selectedOption.value),
        categoryName: categories.find((c) => c.id === categoryId)?.title,
        categoryImage: categories.find((c) => c.id === categoryId)?.images,
        price: selectedTime.price,
        tourName: currentTour?.name,
        routeName: currentTour?.route_name || routeId,
      };

      dispatch(addToCart(cartItem));
      toast.success("Added to cart!");
    }

    return true;
  };

  const routeCartItems =
    cartItems?.filter(
      (item) =>
        item.routeName?.toLowerCase().includes(routeId?.toLowerCase() || "") ||
        item.routeName === routeId,
    ) || [];

  const handleBookNow = () => {
    const isFormFilled = selectedDate && selectedTime && selectedOption;

    // For Asakusa, if they already have items in cart and haven't fully filled a new one,
    // just proceed to checkout with the existing cart.
    if (routeId === "asakusa" && routeCartItems.length > 0 && !isFormFilled) {
      const stateToSave = {
        step: 3,
        shopId,
        categoryId,
        tourId,
      };
      sessionStorage.setItem("monkeyBookingState", JSON.stringify(stateToSave));

      setTimeout(() => {
        window.location.href = `/booking-${routeId}`;
      }, 500);
      return;
    }

    const success = handleAddToCart();
    if (success) {
      // Set session storage so the destination booking page starts at Step 3
      const stateToSave = {
        step: 3,
        shopId,
        categoryId,
        tourId,
        selectedDate,
        selectedTime,
        selectedOption,
      };
      sessionStorage.setItem("monkeyBookingState", JSON.stringify(stateToSave));

      setTimeout(() => {
        window.location.href = `/booking-${routeId}`;
      }, 500);
    }
  };

  const options = selectedTime
    ? Array.from({ length: selectedTime.available_slots }, (_, i) => ({
        value: (i + 1).toString(),
        label: (i + 1).toString(),
      }))
    : [];

  return (
    <div className="w-full animate-fade-in p-2">
      {/* Category Section */}
      <div className="mb-6">
        <h3 className="form_inner_label lg:text-[18px] text-base font-semibold text-[#121212] lg:mb-2 mb-1">
          Select Category
        </h3>
        <div className="flex gap-4">
          {categories.map((item) => (
            <div key={item.id} className="w-1/2 md:w-1/4">
              <input
                type="radio"
                id={`cat-${item.id}`}
                className="peer hidden"
                name={`category_${routeId}`}
                checked={categoryId === item.id}
                onChange={() => {
                  setCategoryId(item.id);
                  setSelectedTime(null);
                  setSelectedOption(null);
                }}
              />
              <label
                htmlFor={`cat-${item.id}`}
                className="block p-3 text-center border-[2px] border-[#ddd] rounded-lg cursor-pointer transition-all peer-checked:border-[#FBBA00] peer-checked:bg-[#FFFAEB]"
              >
                <img
                  src={BaseUrl + item.images}
                  alt={item.title}
                  className="max-w-[80%] mx-auto h-[60px] object-contain mb-2"
                />
                <p className="text-[#442202] font-bold lg:px-[10px] px-[5px] lg:text-[16px] text-[14px] lg:mt-[25px] mt-[10px] mb-0">
                  {item.title}
                </p>
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Tour Section */}
      <div className="mb-6">
        <h3 className="form_inner_label lg:text-[18px] text-base font-semibold text-[#121212] lg:mb-2 mb-1">
          Tour
        </h3>
        <div className="flex flex-col gap-3">
          {tourDetails.map((item) => (
            <div key={item.id} className="relative">
              <input
                type="radio"
                id={`tour-${item.id}`}
                className="peer hidden"
                name={`tour_${routeId}`}
                checked={tourId === item.id}
                onChange={() => {
                  setTourId(item.id);
                  setSelectedTime(null);
                  setSelectedOption(null);
                }}
              />
              <label
                htmlFor={`tour-${item.id}`}
                className="block w-full p-4 border rounded-lg cursor-pointer transition-all peer-checked:border-[#FBBA00] peer-checked:bg-[#FFFAEB]"
              >
                <div className="text-sm font-medium mb-2">{item.name}</div>
                <div className="inline-block bg-[#442202] text-white text-xs py-1 px-3 rounded-full">
                  Time Slot:{" "}
                  {Array.isArray(item.timings)
                    ? item.timings.join(", ")
                    : item.timings?.match(/\d{1,2}\s*[ap]m/gi)?.join(", ") ||
                      item.timings}
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>

      <hr className="my-6 border-gray-200" />

      {/* Calendar and Time Slots */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <h3 className="form_inner_label lg:text-[18px] text-base font-semibold text-[#121212] lg:mb-2 mb-1">
            Tour Date
          </h3>
          <div className="border rounded-lg p-2 bg-white booking-calendar-wrapper">
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              initialDate={defaultDate}
              initialView="dayGridMonth"
              dateClick={handleDateClick}
              selectable={true}
              events={highlightEvent}
              validRange={{ start: defaultDate }}
              height="350px"
            />
          </div>
        </div>

        <div>
          <h3 className="form_inner_label lg:text-[18px] text-base font-semibold text-[#121212] lg:mb-2 mb-1">
            Preferred Time Slot
          </h3>
          <div className="overflow-y-auto h-[350px] space-y-3 pr-2 custom-scrollbar">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <div className="flex flex-col items-center gap-2">
                  <svg
                    className="animate-spin h-8 w-8 text-[#442202]"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    />
                  </svg>
                  <p className="text-[#442202] text-sm font-medium">
                    Loading slots...
                  </p>
                </div>
              </div>
            ) : (
              timeSlots.map((item, index) => (
                <div key={index} className="relative">
                  <input
                    type="radio"
                    id={`slot-${item.id}-${index}`}
                    name={`time_${routeId}`}
                    className="peer hidden"
                    checked={selectedTime?.id === item.id}
                    onChange={() => {
                      setSelectedTime(item);
                      setSelectedOption(null);
                      setShowWarning(false);
                    }}
                    // disabled={item.available_slots === 0}
                    disabled={item.available_slots <= 0}
                  />
                  <label
                    htmlFor={`slot-${item.id}-${index}`}
                    className={`flex items-center justify-between py-[8px] px-[15px] 
                        text-[14px] border border-[#DDDDDD] rounded-[6px] transition-all duration-200
                        
                    ${
                      // item.available_slots === 0
                      item.available_slots <= 0
                        ? "opacity-60 cursor-not-allowed bg-gray-50"
                        : "cursor-pointer peer-checked:border-[#F97316] peer-checked:bg-[#FFF9F4]"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {item.is_hot == 1 && (
                        <span className="flex items-center gap-1 text-[#FF421D] text-[12px] font-semibold absolute bg-white px-[5px] top-[-8px]">
                          🔥 Hot Selling
                        </span>
                      )}
                      <span className="time_text text-[14px] font-medium text-[#666666]">
                        {item.time_slot}
                      </span>
                      {Math.round(((item.mrp - item.price) / item.mrp) * 100) >
                        0 && (
                        <span className="time_percentage py-[2px] px-[8px] bg-[#442202] text-white rounded-[4px] text-[10px] font-medium">
                          {Math.round(
                            ((item.mrp - item.price) / item.mrp) * 100,
                          )}
                          % OFF
                        </span>
                      )}
                      {item.available_slots > 0 &&
                        item.available_slots <= 2 && (
                          <span className="flex items-center gap-1 py-[2px] px-[8px] bg-[#F43F5E] text-white rounded-[4px] text-[10px] font-medium">
                            <HiTrendingUp className="text-[12px]" />
                            {item.available_slots === 1
                              ? "Last Spot"
                              : "Few Left"}
                          </span>
                        )}
                    </div>
                    <span
                      className={`text-xs font-semibold ${item.available_slots <= 0 ? "text-red-500" : "text-green-600"}`}
                    >
                      {/* {item.available_slots === 0 */}
                      {item.available_slots <= 0
                        ? "No slots left"
                        : `${item.available_slots} slot${
                            item.available_slots > 1 ? "s" : ""
                          } left`}
                    </span>
                  </label>
                </div>
              ))
            )}
          </div>

          <div className="mt-4">
            <h3 className="form_inner_label lg:text-[18px] text-base font-semibold text-[#121212] lg:mb-2 mb-1">
              Ride{" "}
              {selectedTime && (
                <span className="text-[#D00000]">
                  (Per Ride ¥{selectedTime.price})
                </span>
              )}
              {!selectedTime && " *"}
            </h3>
            <Select
              options={options}
              value={selectedOption}
              onChange={setSelectedOption}
              isSearchable
              placeholder="Please Select"
              isDisabled={!selectedTime}
              className="text-sm"
            />
          </div>

          <div className="mt-6 flex flex-col gap-3">
            {routeId === "asakusa" && (
              <button
                onClick={handleAddToCart}
                className="w-full bg-[#442202] text-white py-3 rounded-full font-medium hover:bg-[#2d1601] transition-colors"
              >
                Add to Cart
              </button>
            )}
            <button
              onClick={handleBookNow}
              className="w-full bg-[#FBBA00] text-[#442202] py-3 rounded-full font-bold hover:bg-[#e0a600] transition-colors"
            >
              Book Now
            </button>
          </div>

          {/* Cart Items Display - only for Asakusa */}
          {routeId === "asakusa" &&
            routeCartItems &&
            routeCartItems.length > 0 && (
              <div className="mt-6 space-y-4">
                <h5 className="form_inner_label text-[16px] font-semibold text-[#121212] mb-2">
                  Booking Details
                </h5>
                {routeCartItems.map((item) => (
                  <div
                    className="main-selected-booking border-[1px] border-[#DDDDDD] p-3 rounded-[12px] relative"
                    key={item.id}
                  >
                    <div className="flex gap-3 items-center">
                      <div className="cart-icon">
                        <img
                          alt=""
                          className="max-w-[80px]"
                          src={BaseUrl + item.categoryImage}
                        />
                      </div>
                      <div className="text-sm">
                        <p className="text-[#666666] py-[2px] font-medium m-0">
                          Category :{" "}
                          <span className="text-black">
                            {item.categoryName || "Kart"}
                          </span>
                        </p>
                        <p className="text-[#666666] py-[2px] font-medium m-0">
                          Tour Date :{" "}
                          <span className="text-black">
                            {item.date?.split("-").reverse().join("-")}
                          </span>
                        </p>
                        <p className="text-[#666666] py-[2px] font-medium m-0">
                          Tour Time:{" "}
                          <span className="text-black">
                            {item.timeSlot?.time_slot}
                          </span>
                        </p>
                        <p className="text-[#666666] py-[2px] font-medium m-0">
                          Ride :{" "}
                          <span className="text-black">
                            {item.rideCount} x ¥{item.price} = ¥
                            {item.rideCount * item.price}
                          </span>
                        </p>
                      </div>
                    </div>
                    <span>
                      <IoIosCloseCircle
                        className="text-[#D00000] text-[24px] absolute right-[10px] top-[10px] cursor-pointer"
                        onClick={() => dispatch(removeFromCart(item.id))}
                      />
                    </span>
                  </div>
                ))}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default BookingFormContent;
